import { useCampaignScreensPathsChecker } from '@/components/CampaignCreator/hooks/useCampaignScreensPathsChecker';
import { useGetCampaignInfo } from '@/components/CampaignCreator/hooks/useGetCampaignInfo';
import { getCampainCreatorStore, ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { Checkbox } from '@dev/ee-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ReplyToCheckboxProps } from '../../SubjectAndContentInterface';

export const ReplyToCheckbox = (props: ReplyToCheckboxProps): JSX.Element => {
    const { showReplyTo, setShowReplyTo } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { activeTemplateIndex } = useSelector(getCampainCreatorStore);
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { fromEmail, fromName } = useGetCampaignInfo();

    const switchDifferentReplyTo = (): void => {
        if (!showReplyTo) {
            setShowReplyTo(!showReplyTo);
            return;
        }
        const modifyMap = new Map<string, any>();
        modifyMap.set(`CampaignTemplates[${activeTemplateIndex}].Sender.ReplyName`, fromName);
        modifyMap.set(`CampaignTemplates[${activeTemplateIndex}].Sender.ReplyTo`, [fromEmail]);
        dispatch(ModifyCampaignMap(modifyMap));
        setShowReplyTo(!showReplyTo);
    };

    return (
        <Checkbox
            id="checkbox-use-different-reply-to"
            onChange={switchDifferentReplyTo}
            checked={showReplyTo}
            labelPlacement="end"
            label={t('usedifferentreplyto')}
            disabled={isDetailsScreen}
        />
    );
};
